import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";

interface Props {
    onClick?: () => void;
}

const OldBackButton: React.FC<Props> = ({ onClick }) => {
    const navigate = useNavigate()

    const handleClick = () => {
        if (onClick) {
            onClick();
        } else {
            navigate(-1);
        }
    };
    
    return (
        <Button
            className="h-[55px] flex items-center space-x-[20px] rounded-md cursor-pointer"
            onClick={handleClick}
            variant="white"
            size="sm"
        >
            <ArrowLeftIcon/>
            <div className="uppercase text-xs font-bold">
                Indietro
            </div>
        </Button>
    );
}

export default OldBackButton

interface ArrowLeftIconProps extends React.SVGProps<SVGSVGElement> {}

const ArrowLeftIcon: React.FC<ArrowLeftIconProps> = ({ className, ...props }) => {
  return (
    <svg
      viewBox="0 0 21 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`w-[21px] h-[16px] ${className}`}
      {...props}
    >
      <path
        d="M19.5 8.99999C20.0523 8.99999 20.5 8.55227 20.5 7.99999C20.5 7.4477 20.0523 6.99999 19.5 6.99999L19.5 8.99999ZM0.292893 7.29289C-0.0976314 7.68342 -0.0976315 8.31658 0.292894 8.70711L6.65686 15.0711C7.04738 15.4616 7.68055 15.4616 8.07107 15.0711C8.4616 14.6805 8.4616 14.0474 8.07107 13.6568L2.41421 8L8.07106 2.34314C8.46159 1.95262 8.46159 1.31945 8.07106 0.928926C7.68054 0.538402 7.04737 0.538403 6.65685 0.928927L0.292893 7.29289ZM19.5 6.99999L1 7L1 9L19.5 8.99999L19.5 6.99999Z"
        fill="currentColor"
      />
    </svg>
  );
};
